// extracted by mini-css-extract-plugin
module.exports = {"header":"messageSimplifiedHeader_header__2KqfA"};